import {API_BASE_URL} from "@/config";
import {getCSRFToken} from "@/store/auth";

export const fetchOrganisations = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/organisations`, {
            method: 'GET',
            credentials: 'include',
        })
        return await response.json()
    } catch (error) {
        console.error('Error fetching organisations:', error)
        throw error
    }
}

export const fetchAdminOrganisations = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/admin/organisations`, {
            method: 'GET',
            credentials: 'include',
        })
        return await response.json()
    } catch (error) {
        console.error('Error fetching admin organisations:', error)
        throw error
    }
}

export const fetchUserShifts = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/current-user/user-shifts`, {
            method: 'GET',
            credentials: 'include',
        })
        const data = await response.json()
        return data.user_shifts
    } catch (error) {
        console.error('Error fetching user shifts:', error)
        throw error
    }
}

export const fetchOrganisationRoles = async (organisationSlug) => {
    try {
        const response = await fetch(`${API_BASE_URL}/organisations/${organisationSlug}/roles`, {
            method: 'GET',
            credentials: 'include',
        })
        const data = await response.json()
        return data.roles
    } catch (error) {
        console.error('Error fetching roles:', error)
        throw error
    }
}

export const deleteUserRole = async (userRoleId) => {
    // Delete the specified user role
    try {
        const response = await fetch(`${API_BASE_URL}/user-roles/${userRoleId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken(),
            },
            credentials: 'include',
        });
        if (!response.ok) {
            console.error('Failed to delete UserRole');
        }
    } catch (error) {
        console.error('Error deleting UserRole:', error);
    }
};

export const createUserRole = async (roleId) => {
    // Create a new user role for the current user
    try {
        const response = await fetch(`${API_BASE_URL}/roles/${roleId}/user-roles`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken(),
            },
            credentials: 'include',
            body: JSON.stringify({role_id: roleId}),
        });
        if (!response.ok) {
            console.error('Failed to create UserRole');
        }
    } catch (error) {
        console.error('Error creating UserRole:', error);
    }
}
